; "use strict";

import State from '../state';
import drugData from '../drugdata';
import methData from './hobl-meth';
import methods from '../methods';

const sections = [
				'Базовые', // 0 
				'ДДАХ/ДДБА', // 1 
				'ИГКС/ДДБА', // 2 
				'ДДАХ/ДДБА/ИГКС', // 3 
				'ИГКС/ДДАХ/рофлумиласт', // 4
				'ДДАХ/ДДБА/ИГКС/рофлумиласт', // 5 
				'ИГКС/ДДБА/теофиллин' // 6
				];

class HoblModel {

	constructor() {

		let group;

		this.currSection = 0;
		for(group in methData) State.baPatsBuf[group] = -1;
	}

/////////////////////////////

	getSections() {

		return sections;
	}


/////////////////////////////

	calcOneGroup(st, chan) {

		let cnt, len, drugSet, doseSet, nOfDrugs, currDrugN, nOfPatients, mgTotal, nOfDays,
			cycleDose, currDrug, drugIndex, nOfCycles, currPrice, cyclesRound, currMeth,
			drugDose, drugBudget, methodBudget, groupBudget, drugPack, nOfPacks;

//!!TODO Возможно просто вызвать calcOneGroup из модуля Calc

		const methSet = methData[st].meth;
		const currPath = State.currPath;
//console.log(st);
//if(st!='st0_2_6') return 0;
//console.log('------------>');
		groupBudget = 0;
		len = methSet.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			currMeth = methSet[cnt].meth;
			drugSet = methods[currMeth].drugs;
			doseSet = methods[currMeth].dose;
			nOfDrugs = drugSet.length;
			nOfDays = methSet[cnt].days;
			nOfCycles = methSet[cnt].cycles; // N of infusions for year 
										// for current method of therapy
if(chan=='oms') nOfPatients = methSet[cnt].oms;
else if(chan=='omsd') nOfPatients = methSet[cnt].omsd;
else if(chan=='rlo') nOfPatients = methSet[cnt].rlo;
else if(chan=='onls') nOfPatients = methSet[cnt].onls;
else nOfPatients = methSet[cnt].pats;
//!!TODO Временная заглушка для маленьких групп распределения, когда
//		nOfPatients некорректно расчитывается
				if(isNaN(nOfPatients)) continue; 
			methodBudget = 0;							
//console.log(State.drugBuf);
			for(currDrugN=0 ; currDrugN<nOfDrugs ; currDrugN++) {
				drugIndex = drugSet[currDrugN];
				cycleDose = doseSet[currDrugN];
// console.log(drugIndex);
// if(drugIndex==2) console.log(drugData);
				currDrug = drugData[drugIndex];

				currPrice = currDrug.price; // Price of one pack
				drugDose = currDrug.dose;	// Dose of one tablet or flask
				drugPack = currDrug.set;		// N of items in pack

// Вариант округляющий упаковки до курса для таблеток и до цикла для флаконов
if(currDrug.tab) { // Таблетированная форма
	nOfPacks = Math.ceil(cycleDose/drugDose); // Таблеток на цикл
	nOfPacks = Math.ceil(nOfPacks*nOfDays[currDrugN]*nOfCycles[currDrugN]/drugPack); // Пачек на курс
	nOfPacks = nOfPacks*nOfPatients // Пачек на курс на всех
}
else {
	nOfPacks = Math.ceil(cycleDose/drugDose/drugPack); // Упаковок на цикл
	nOfPacks = nOfPatients*Math.ceil(nOfPacks*nOfDays[currDrugN]*nOfCycles[currDrugN]);
}
	mgTotal = Math.round(nOfPacks*drugDose*drugPack); 

				nOfPacks = Math.ceil(nOfPacks);
				drugBudget = nOfPacks*currPrice;
// if(st=='st0_0_3') {
// 	console.log(currDrug.name);
// 	console.log('!!-'+drugBudget);
// 	console.log(cycleDose);//2
// 	console.log(drugDose);//2
// 	console.log(Math.ceil(cycleDose/drugDose));//1 
// 	console.log(cycleDose/drugDose);//1
// 	console.log(drugPack);//10
// 	console.log(nOfDays[currDrugN]);//15
// 	console.log(nOfCycles[currDrugN]);//1
// 	console.log(drugPack);//10
// 	console.log(nOfPacks);//2
// }
				State.drugBuf[drugIndex].summ += drugBudget;
				State.drugBuf[drugIndex].packs += nOfPacks;
				State.drugBuf[drugIndex].mg += mgTotal;
				methodBudget += drugBudget;
				if(chan=='oms') {		
					State.omsBuf[drugIndex].summ += drugBudget;
					State.omsBuf[drugIndex].packs += nOfPacks;
					State.omsBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}
				if(chan=='omsd') {		
					State.omsdBuf[drugIndex].summ += drugBudget;
					State.omsdBuf[drugIndex].packs += nOfPacks;
					State.omsdBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
				}
				if(chan=='rlo') {
					State.rloBuf[drugIndex].summ += drugBudget;
					State.rloBuf[drugIndex].packs += nOfPacks;
					State.rloBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
					State.nOfRloPats[currPath] += nOfPatients;
				}
				if(chan=='onls') {
// if(st=='st0_0_1') {
// 	console.log('-----------');
// 	console.log(currDrug.name);
// 	console.log(nOfPatients);
// 	console.log(drugBudget);
// }
					State.onlsBuf[drugIndex].summ += drugBudget;
					State.onlsBuf[drugIndex].packs += nOfPacks;
					State.onlsBuf[drugIndex].mg += mgTotal;
					State.chanBudgets[chan] += drugBudget;
					State.nOfOnlsPats[currPath] += nOfPatients;
				}	
			}
			groupBudget += methodBudget;	
			if(chan=='oms') {		
				State.stIncome += nOfPatients*
				State.distPanel.calcMethodIncome(methods[currMeth].st, methSet[cnt].cycles[0]); 	
				cyclesRound = Math.ceil(methSet[cnt].cycles[0]);
				State.nOfCasesKs += nOfPatients*cyclesRound;
				if(methods[currMeth].st && methods[currMeth].st!='') {
					State.ksgBuf[methods[currMeth].st] += nOfPatients*cyclesRound;
				}
			}
			if(chan=='omsd') {		
				State.dsIncome += nOfPatients*
				State.distPanel.calcMethodIncome(methods[currMeth].ds, methSet[cnt].cycles[0]); 	
				cyclesRound = Math.ceil(methSet[cnt].cycles[0]);
				State.nOfCasesDs += nOfPatients*cyclesRound;
				if(methods[currMeth].ds && methods[currMeth].ds!='') {
					State.ksgBuf[methods[currMeth].ds] += nOfPatients*cyclesRound;
				}
			}
		}
	return groupBudget;
	}

/////////////////////////////
// input - число пациентов, которое необходимо распределить
// probBuf - ссылка на массив процентов распределения
// 			!! Для дополнительных пациентов вероятность приходить в отрицательном значении,
//				чтобы расположить их первыми в алгоритме ранжирования
// patByf - ссылка на массив распределенных пациентов
// extra - дополнительные фиктивные пациенты, необходимые для расчета медикаментов,
//		добавляемых сверх реального распределения, например - амброксол. Отдельной 
//		группы пациентов с амброксолом нет, но 20% пациентов его получает, независимо
//		от того, в какую группу они попадают. 

// Версия с обратным проходом от маленьких вероятностей к большим
// из модуля РП

	disributePats(input, probBuf, patBuf, extra) {

		let len = probBuf.length, i, minInd, rest, pats, data;
		let probList = []; // Массив индексов элементов из probBuf, отсортированных
							// по убыванию
		let buf = [];
		let extraRest = extra;					
		for(i=0 ; i<len ; i++) {
			buf.push(probBuf[i]);
		}
		for(i=0 ; i<len ; i++) {
			minInd = State.calc.findMin(buf);
			probList.push(minInd);
			buf[minInd] = 200;
		}

// В probList теперь указатели на элементы массива вероятностей probBuf в возрастающем
// порядке
// Отдаем приоритет позициям с меньшей вероятностью!!
		rest = input; // Нераспределенный остаток
//		if(extra) rest += extra;

		for(i=0 ; i<len ; i++) {
			data = input*probBuf[probList[i]]/100;
			if(data<0) { 
				data = 0 - data;
				pats = Math.round(data);
				if(pats>extraRest) pats = extraRest;
				patBuf[probList[i]] = pats;
				extraRest -= pats;
				if(extraRest<0) extraRest = 0;
			} else {
				pats = Math.round(data);
				if(pats>rest) pats = rest;
				patBuf[probList[i]] = pats;
				rest -= pats;
				if(rest<0) rest = 0;
			}	
		}
		if(rest>0) patBuf[probList[len-1]] += rest;
		if(extraRest>0) patBuf[probList[0]] += extraRest;
	}
 
/////////////////////////////
// Распределяем кол-ва пациентов в группе по методам с недостатком

	distributeCutMeth(group, ratio) {

		let flSt3;
		let pathData, prob;

		if(State.flNoDist)	return;

		pathData = methData;
		let methSet = pathData[group]['meth'];
		let len, i, res, total, extraPats, probBuf=[], patBuf=[];
// Формируем массив вероятностей
		total = pathData[group].pats;
		total = Math.round(total);
		// len = methSet.length;
		// for(i=0 ; i<len ; i++) {
		// 	prob = methSet[i].rate;
		// 	probBuf.push(prob*ratio);
		// 	patBuf.push(0);
		// }
		// this.disributePats(total, probBuf, patBuf, 0);
		len = methSet.length;
		extraPats = 0;
		for(i=0 ; i<len ; i++) {
			if(methSet[i].rate<0) extraPats += Math.abs(methSet[i].rate);
			probBuf.push(methSet[i].rate*ratio);
			patBuf.push(0);
		}
		extraPats = Math.floor(total*extraPats*ratio/100.0);
State.extraPats['ba'][group] = extraPats;		
this.disributePats(total, probBuf, patBuf, extraPats);
		for(i=0 ; i<len ; i++) {
			res = patBuf.splice(0,1);
			methSet[i].pats = res[0]; 
		}
	}

/////////////////////////////
// Распределяем кол-ва пациентов в группе по методам для группы с избытком

	distributeExtraMeth(group) {

		let pathData, extraPats;

		if(State.flNoDist) return; // Отладочный режим

		pathData = methData;
		let methSet = pathData[group]['meth'];
		let len, i, res, total, probBuf=[], patBuf=[];
// Формируем массив вероятностей
		if(pathData[group].result!=-1) total = pathData[group].result;
		else total = pathData[group].pats;
		len = methSet.length;
		extraPats = 0;
		for(i=0 ; i<len ; i++) {
			if(methSet[i].rate<0) extraPats += Math.abs(methSet[i].rate);
			probBuf.push(methSet[i].rate);
			patBuf.push(0);
		}
		extraPats = Math.floor(total*extraPats/100.0);
State.extraPats['ba'][group] = extraPats;		
this.disributePats(total, probBuf, patBuf, extraPats);
		for(i=0 ; i<len ; i++) {
			res = patBuf.splice(0,1);
			methSet[i].pats = res[0]; 
		}
	}

/////////////////////////////
// Суммируем для текущией патологии всех пациентов для данной группы
// Необходима в случае, если сумма процентов для всех методов в группе больше 100%

	summGroupPats(group) {

		let totalPatsBuf = State.stPats[2];
		let total = totalPatsBuf[group];
		let methSet = methData[group].meth;
		let summ = 0, len, i, pats;

		len = methSet.length;
		for(i=0 ; i<len ; i++) {
			pats = Math.abs(total*methSet[i].rate/100.0);
			summ += pats;
		}
		return summ;
	}

/////////////////////////////
// Распределяем пациентов по методам для группы с суммой процентов меньше
// 100%
//

	distributeOneCutGroup(currGroup) {

		let i, pats;
		let stPats = State.stPats[2];
// Для группы нужно пересчитать общее количество пациентов,
// исходя из того, что сумма процентов по методам не равна 100%
// Суммируем пациентов внутри группы
			let currGrData = methData[currGroup].meth;
			let grSumm = 0, len = currGrData.length, num, ratio;
			if(methData[currGroup].result != -1) pats = methData[currGroup].result;
			else pats = methData[currGroup].pats;
			for(i=0 ; i<len ; i++) {
				num = currGrData[i].rate*pats/100.0;
				if(!State.flNoDist)	currGrData[i].pats = num;
if(num>=0) grSumm += num;
			}
			grSumm = Math.floor(grSumm);			
			if(grSumm==0) ratio = 1;
			else ratio = pats/grSumm;			
// Перезаписываем новое значение в группу
			grSumm = Math.ceil(grSumm);
			methData[currGroup].pats = grSumm;
// Для каждой группы перераспределяем пациентов по методам
			this.distributeCutMeth(currGroup, ratio);
// Сохраняем реальное кол-во пациентов для расчета нераспределенных 
			State.hoblFreePatsBuf[currGroup] = methData[currGroup].pats;
// Восстанавливаем затертое начальное распределение 
if(State.hoblPatsBuf[currGroup])			
			methData[currGroup].pats = State.hoblPatsBuf[currGroup];
return methData[currGroup].pats;
//return grSumm;
	}

/////////////////////////////
// Распределяем пациентов по методам для группы с суммой процентов больше
// или равно 100%

	distributeOneExtraGroup(currGroup) {

		let i, pats;
// Восстанавливаем исходное распределение пациентов, нарушенное при предыдущем
// проходе процедуры

			if(State.hoblPatsBuf[currGroup]!=-1) {
				methData[currGroup].pats = State.hoblPatsBuf[currGroup]; 
			}

			let currGrData = methData[currGroup].meth;
			let hoblGrSumm = 0, percentSumm = 0, len = currGrData.length, num;
			
// Вводилось ли число пациентов в группе вручную и делался ли раньше перерасчет на превышение 100%
// Ручной ввод хранится в result!
			if(methData[currGroup].result!=-1 && State.hoblMultBuf[currGroup]) {
				pats = Math.round(methData[currGroup].result/State.hoblMultBuf[currGroup]);
			} else if(methData[currGroup].result!=-1 && isNaN(State.hoblMultBuf[currGroup])) {
				pats = Math.round(methData[currGroup].result);
			}
			else {
				pats = methData[currGroup].pats;
			} 
			for(i=0 ; i<len ; i++) {
				num = Math.abs(currGrData[i].rate*pats/100.0);
				if(!State.flNoDist)	currGrData[i].pats = num; 
				if(currGrData[i].rate>0) hoblGrSumm += num;
			}
			methData[currGroup].pats = pats;
// Для каждой группы перераспределяем пациентов по методам
			this.distributeExtraMeth(currGroup);
//!!D Сохраняем реальное кол-во пациентов для расчета нераспределенных 
State.hoblFreePatsBuf[currGroup] = methData[currGroup].pats;
// Сохраняем множитель распределения в буфере
			State.hoblMultBuf[currGroup] = hoblGrSumm/pats;
// Сохраняем начальное распределение в буфере
			State.hoblPatsBuf[currGroup] = pats;			
			return pats;
	}

/////////////////////////////
// Распределяем общее число пациентов по методам для всех групп
//

	distributeAllMeth() {

		let i, percentSumm, currGroup, pats, len, meth;
		let pathSumm = 0; // Накопитель для фактической суммы пациентов проходящих
							// терапию в течение года 

		for(currGroup in methData) {
			meth = methData[currGroup].meth;
			len = meth.length;
			percentSumm = 0;
			for(let cnt=0 ; cnt<len ; cnt++) {
				if(meth[cnt].rate>=0) percentSumm += meth[cnt].rate;
			}
			if(percentSumm>100) {
				pathSumm += this.distributeOneExtraGroup(currGroup);
			}
			else {
				pathSumm += this.distributeOneCutGroup(currGroup);
			}
		}

		// Сохраняем полное фактическое кол-во пациентов в хранилище
		State.pathSumm[2] = pathSumm;
	}


/////////////////////////////
// Распределяем общее число пациентов текущего региона по стадиям
// и группам для РП

	distributeSt() {

		let Data = methData, currGroup,i, indStr;
		let stPats = [], total = State.pathTotals[2];
		let totalPatsBuf = State.stPats[2];
		const grProbs = [30, 30, 10, 30],
				manifProbs = [25,50,100,100];
		let grPats = [], manifPats = []; 
		for(i=0 ; i<4 ; i++) {
			grPats[i] = total*grProbs[i]/100.0;
			grPats[i+4] = grPats[i];
			manifPats[i] = grPats[i]*manifProbs[i]/100.0;
		}
		let patSumm = 0, delta, maxQuant = 0, maxInd;
		
		for(i=0 ; i<4 ; i++) {
			if(grPats[i]>maxQuant) {
				maxQuant = grPats[i];
				maxInd = i+1;
			}
		}

// Группа A, постоянный прием
		Data['st0_0_1'].pats = Math.round(grPats[0]);
		totalPatsBuf['st0_0_1'] = Math.round(grPats[0]);
patSumm += Data['st0_0_1'].pats;
// Группа B, постоянный прием
		Data['st0_0_2'].pats = Math.round(grPats[1]);
		totalPatsBuf['st0_0_2'] = Math.round(grPats[1]);
patSumm += Data['st0_0_2'].pats;

// Группа C, постоянный прием
		Data['st0_0_3'].pats = Math.round(grPats[2]);
		totalPatsBuf['st0_0_3'] = Math.round(grPats[2]);
patSumm += Data['st0_0_3'].pats;

// Группа D, постоянный прием
		Data['st0_0_4'].pats = Math.round(grPats[3]);
		totalPatsBuf['st0_0_4'] = Math.round(grPats[3]);
patSumm += Data['st0_0_4'].pats;

// Группа A, по потребности
		Data['st0_0_5'].pats = Math.round(grPats[4]);
		totalPatsBuf['st0_0_5'] = Math.round(grPats[4]);

// Группа B, по потребности
		Data['st0_0_6'].pats = Math.round(grPats[5]);
		totalPatsBuf['st0_0_6'] = Math.round(grPats[5]);

// Группа C, по потребности
		Data['st0_0_7'].pats = Math.round(grPats[6]);
		totalPatsBuf['st0_0_7'] = Math.round(grPats[6]);

// Группа D, по потребности
		Data['st0_0_8'].pats = Math.round(grPats[7]);
		totalPatsBuf['st0_0_8'] = Math.round(grPats[7]);

// Группа A, обострение
		Data['st0_0_9'].pats = Math.round(manifPats[0]);
		totalPatsBuf['st0_0_9'] = Math.round(manifPats[0]);

// Группа B, обострение
		Data['st0_0_10'].pats = Math.round(manifPats[1]);
		totalPatsBuf['st0_0_10'] = Math.round(manifPats[1]);

// Группа C, обострение
		Data['st0_0_11'].pats = Math.round(manifPats[2]);
		totalPatsBuf['st0_0_11'] = Math.round(manifPats[2]);

// Группа D, обострение
		Data['st0_0_12'].pats = Math.round(manifPats[3]);
		totalPatsBuf['st0_0_12'] = Math.round(manifPats[3]);


// Убираем ошибку округлений за счет значения в группе с наибольшим кол-вом пациентов
		delta = patSumm - total;
		if(delta!=0) {
			indStr = 'st0_0_' + maxInd;
			Data[indStr].pats -= delta;
			totalPatsBuf[indStr] -= delta;
		}
let pathSumm = 0;
		for(currGroup in Data) {
// Для каждой группы нужно расчитать и сохранить в State.rlPatsBuf общее количество пациентов,
// т.к. после ручного ввода и перераспределения, исходные значения буду перезаписаны
State.hoblPatsBuf[currGroup] = Data[currGroup].pats;
//D			State.baPatsBuf[currGroup] = -1;
			Data[currGroup].result = -1;
pathSumm += Data[currGroup].pats;
		}
	
State.pathSumm[2] = pathSumm;
		this.distributeAllMeth();
	}

}

export default HoblModel;